import { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';

import { buildProjectPath, buildProposalPath, projectPaths } from '../../paths/project';

export { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';

interface UseProjectBasePathOptions {
  ignoreProposal?: boolean;
}

export const useProjectBasePath = (options?: UseProjectBasePathOptions): string => {
  const { isInProposal, projectId, proposalId } = useProposalContext();

  if (!projectId) {
    return '';
  }

  const basePath = buildProjectPath(projectId);

  if (options?.ignoreProposal) {
    return basePath;
  }

  return isInProposal && proposalId ? buildProposalPath(projectId, proposalId) : basePath;
};

export const useProjectBaseRoutePath = (options?: UseProjectBasePathOptions): string => {
  const { isInProposal } = useProposalContext();

  if (options?.ignoreProposal) {
    return projectPaths.BASE;
  }

  return isInProposal ? projectPaths.PROPOSAL : projectPaths.BASE;
};
